// Polish locale - V2 (currently mostly empty, falls back to FR).
import fr from "./fr";

const pl = {
  ...fr,
  langBanner: {
    ...fr.langBanner,
    plTitle: "Wkrótce dostępna polska wersja",
    plBody: "Tymczasowo pokazujemy francuską wersję. Zapisz się, aby otrzymać powiadomienie.",
    switchToFr: "Zobacz po francusku",
    dismiss: "Zamknij",
  },
};

export default pl;
